import * as React from 'react'
import { observer } from 'mobx-react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderExtras,
} from 'components/StickyViewHeader'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'
import Button from 'components/Button'
import WorkspaceSelectorViewHeading from 'components/WorkspaceSelectorViewHeading'
import Workspace from 'iam/models/Workspace'
import AdminBundleManagerViewModel from 'admin/bundle/BundleManagerViewModel'
import { TabBar, TabItem } from 'components/TabBar'
import { BundleArchivedFilterOptions } from 'admin/bundle/BundleRequestQueryFilterBuilder'

interface BundleManagerHeaderProps {
  scrollOffset: ScrollOffsetInterpolation
  vm: AdminBundleManagerViewModel
}

export default observer(function BundleManagerHeader({
  scrollOffset,
  vm,
}: BundleManagerHeaderProps) {
  return (
    <StickyViewHeader
      bordered
      scrollOffset={scrollOffset}
      tabBar={
        <TabBar align="left">
          <TabItem
            active={
              vm.currentArchivedStatusTab === BundleArchivedFilterOptions.ACTIVE
            }
            onClick={() =>
              vm.setCurrentArchivedStatusTab(BundleArchivedFilterOptions.ACTIVE)
            }
            dataTest="bundle-manager-tab-active"
          >
            Active
          </TabItem>
          <TabItem
            active={
              vm.currentArchivedStatusTab ===
              BundleArchivedFilterOptions.ARCHIVED
            }
            onClick={() =>
              vm.setCurrentArchivedStatusTab(
                BundleArchivedFilterOptions.ARCHIVED,
              )
            }
            dataTest="bundle-manager-tab-archived"
          >
            Archived
          </TabItem>
        </TabBar>
      }
    >
      <StickyViewHeaderMain>
        <WorkspaceSelectorViewHeading
          primaryText={'Bundle manager'}
          allOptionDropdownItem={
            vm.canManageBundles ? <>All workspaces</> : null
          }
          alwaysUseDropdown={vm.workspacesUseDropdown}
          workspaces={vm.workspaces}
          dropdownTitle="Select workspace"
          onChange={vm.selectWorkspaceForFiltering}
          searcher={vm.canSearch ? vm.workspaceSearcher : undefined}
          renderName={(workspace) => {
            return <>{workspace.name}</>
          }}
          allOptionText={vm.canManageBundles ? 'All workspaces' : null}
          value={
            vm.workspaceFilter.type === 'AllWorkspaces'
              ? Workspace.none
              : vm.workspaceFilter.workspace
          }
        />
      </StickyViewHeaderMain>
      <StickyViewHeaderExtras>
        <AddBundleButton vm={vm} />
      </StickyViewHeaderExtras>
    </StickyViewHeader>
  )
})

interface AddBundleDropdownProps {
  vm: AdminBundleManagerViewModel
}

const AddBundleButton = ({ vm }: AddBundleDropdownProps) => {
  return (
    <Button
      submit
      dataTest="add-bundle-header-button"
      onClick={() => vm.createBundleViewModel.open()}
    >
      Add Bundle
    </Button>
  )
}
